import BsiButton, { type Props as BsiButtonProps } from './BsiButton'

export {
  BsiButton,
  type BsiButtonProps
}

export default BsiButton
